import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watchEffect, onMounted, ref } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
watchEffect(() => {
  // 检查当前路由的 meta 字段中是否有 title
  if (route.meta && (route.meta.title as string)) {
    document.title = route.meta.title as string;
  }
  document.documentElement.classList.add("dark");
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})